// Restaurant content for Cantaritos Dallas (placeholder data — easily editable)

export const SITE = {
  name: 'Cantaritos Dallas',
  tagline: 'Mezcalería · Cocina de México',
  phone: '(214) 555-0142',
  email: 'hola@cantaritosdallas.com',
  address: '1500 Agave Lane, Dallas, TX 75201',
  hours: [
    { day: 'Lun — Jue', time: '4:00 PM – 11:00 PM' },
    { day: 'Viernes', time: '4:00 PM – 1:00 AM' },
    { day: 'Sábado', time: '12:00 PM – 1:00 AM' },
    { day: 'Domingo', time: '12:00 PM – 10:00 PM' },
  ],
  socials: {
    instagram: 'https://instagram.com',
    facebook: 'https://facebook.com',
    tiktok: 'https://tiktok.com',
  },
};

export const IMAGES = {
  heroCantarito: 'https://images.unsplash.com/photo-1701680607066-be1f8a7322f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxtZXhpY2FuJTIwY29ja3RhaWwlMjBjYW50YXJpdG8lMjBjbGF5JTIwY3VwfGVufDB8fHx8MTc4MTczNzEwMXww&ixlib=rb-4.1.0&q=85',
  cantarito2: 'https://images.unsplash.com/photo-1701680607096-4cf745cc8ff8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxtZXhpY2FuJTIwY29ja3RhaWwlMjBjYW50YXJpdG8lMjBjbGF5JTIwY3VwfGVufDB8fHx8MTc4MTczNzEwMXww&ixlib=rb-4.1.0&q=85',
  cantarito3: 'https://images.unsplash.com/photo-1701680607067-8b9ea74c5372?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxtZXhpY2FuJTIwY29ja3RhaWwlMjBjYW50YXJpdG8lMjBjbGF5JTIwY3VwfGVufDB8fHx8MTc4MTczNzEwMXww&ixlib=rb-4.1.0&q=85',
  tacos1: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxtZXhpY2FuJTIwZm9vZCUyMHRhY29zJTIwdmlicmFudHxlbnwwfHx8fDE3ODE3MzcxMDF8MA&ixlib=rb-4.1.0&q=85',
  tacos2: 'https://images.unsplash.com/photo-1551504734-5ee1c4a1479b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxtZXhpY2FuJTIwZm9vZCUyMHRhY29zJTIwdmlicmFudHxlbnwwfHx8fDE3ODE3MzcxMDF8MA&ixlib=rb-4.1.0&q=85',
  mariachi: 'https://images.unsplash.com/photo-1654576205088-6503ad4ffb72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxtYXJpYWNoaSUyMGJhbmQlMjBsaXZlJTIwbXVzaWN8ZW58MHx8fHwxNzgxNzM3MTAxfDA&ixlib=rb-4.1.0&q=85',
  interior: 'https://images.unsplash.com/photo-1653084019129-1f2303bb5bc0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxtZXhpY2FuJTIwcmVzdGF1cmFudCUyMGludGVyaW9yJTIwd2FybSUyMHZpYnJhbnR8ZW58MHx8fHwxNzgxNzM3MTAxfDA&ixlib=rb-4.1.0&q=85',
};

export const MENU = [
  {
    category: 'Cantaritos',
    blurb: 'Nuestra alma — coolers de tequila y mezcal servidos en jarrito de barro sobre cítricos.',
    items: [
      { name: 'Cantarito Clásico', desc: 'Tequila blanco, limón, naranja, refresco de toronja, escarchado de chamoy', price: '14' },
      { name: 'Cantarito de Mezcal', desc: 'Mezcal espadín, naranja, toronja, sal de gusano', price: '16' },
      { name: 'Cantarito Picante', desc: 'Tequila reposado, jalapeño, tamarindo, escarchado de Tajín', price: '15' },
      { name: 'Cantarito de la Casa', desc: 'Mezcla de la casa, jamaica, naranja sangría, toronja rosa', price: '17' },
    ],
  },
  {
    category: 'Mezcal y Agave',
    blurb: 'Una selección de agaves traída directo de las sierras de México y Oaxaca.',
    items: [
      { name: 'Espadín Joven', desc: 'Brillante, cítrico, humo suave', price: '13' },
      { name: 'Degustación Tobalá', desc: 'Tres servicios de 1oz de mezcal de agave silvestre', price: '28' },
      { name: 'Tequila Reserva', desc: 'Añejo reposado 18 meses en roble', price: '19' },
      { name: 'Raicilla del Pueblo', desc: 'Destilado de agave costero, poco común', price: '21' },
    ],
  },
  {
    category: 'Antojitos',
    blurb: 'Platillos estilo callejero para compartir entre tragos.',
    items: [
      { name: 'Tacos al Pastor', desc: 'Cerdo adobado, piña, cebolla, cilantro (3)', price: '13' },
      { name: 'Birria Quesatacos', desc: 'Res cocida a fuego lento, queso Oaxaca fundido, consomé (3)', price: '15' },
      { name: 'Elote en Vaso', desc: 'Elote asado, crema, cotija, chile, limón', price: '9' },
      { name: 'Guacamole de Molcajete', desc: 'Aguacate machacado a mano, serrano, totopos', price: '12' },
    ],
  },
  {
    category: 'Platos Fuertes',
    blurb: 'Platillos abundantes con raíces en la cocina de México.',
    items: [
      { name: 'Carne en su Jugo', desc: 'Res tierna, tocino, frijoles, salsa verde', price: '22' },
      { name: 'Pescado Zarandeado', desc: 'Pescado a la leña, achiote, cítricos, tortillas', price: '26' },
      { name: 'Molcajete Mixto', desc: 'Arrachera, chorizo, camarón, nopales, queso fundido', price: '34' },
      { name: 'Pozole Rojo', desc: 'Caldo de maíz, cerdo, rábano, orégano, limón', price: '17' },
    ],
  },
];

export const EVENTS = [
  { date: 'JUN 12', day: 'Jueves', band: 'Mariachi Sol de México', genre: 'Mariachi · 8:00 PM', img: 'mariachi' },
  { date: 'JUN 14', day: 'Sábado', band: 'Los Cantaritos del Norte', genre: 'Norteño · 9:30 PM', img: 'mariachi' },
  { date: 'JUN 20', day: 'Viernes', band: 'Banda Tierra Caliente', genre: 'Banda Sinaloense · 9:00 PM', img: 'mariachi' },
  { date: 'JUN 21', day: 'Sábado', band: 'Trío Romántico Guadalajara', genre: 'Bolero · 7:30 PM', img: 'mariachi' },
  { date: 'JUN 27', day: 'Viernes', band: 'Grupo Agave Vivo', genre: 'Cumbia · 9:30 PM', img: 'mariachi' },
];
